import React from "react";
import When from "../../common/components/When";
import classNames from "classnames";

import Label from "../../common/components/Label";

const DisseminatedOn = (props) => (
    <div style={Object.assign({}, props.style)} className={classNames("pure-control-group", props.className)}>
        <Label htmlFor="disseminatedOn" style={props.labelStyle}>When?</Label>
        <When id="disseminatedOn" {...props} />
    </div>
);
DisseminatedOn.propTypes = {
    className: React.PropTypes.string
};

export default DisseminatedOn;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/DisseminatedOn.js
 **/